<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
import { API } from '@lib/processors/api-processor'

export default {
  name: 'AdminPanel',
  computed: {
    ...mapGetters('ui', [
      'menu',
    ]),
    ...mapGetters('auth', [
      'loggedIn',
    ]),
  },
  methods: {
    handleLoginEvent(data) {
      Vue.prototype.$accessToken = data.accessToken
      API.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`

      window.gtag('set', {
        user_id: data.decodedToken['https://eonx.com/user'].id,
      })

      this.$store.dispatch('me/GET_ME', data)
      this.$store.dispatch('providers/GET_PROVIDERS')
    },
  },
}
</script>

<template>
  <app-layout
    :menu="menu"
    title="Community Hub"
  >
    <router-view />
    <base-modal-wrapper />
  </app-layout>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
  #nprogress .bar {
    background: var(--color-link);
  }

  .el-notification__content {
    text-align: left;
  }
</style>
